module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAMFBMVEUAAADBJyzDJCy/KCi/ICDAJi2/JSrAJyzAJizAJi3AJy3BJyzBJizCJi3BJi3BJy1QM2gpAAAAD3RSTlMAwEAgEPAwv6/v35CAULCvdyvbAAAAoUlEQVQoz2MgFuhUTj+EzPf4DwQtCD7b+mgVp62/EuACXh8NGBiY5ZfABd4LgEjGHzA+01cDEMUcrwAV4PkNofcfgAowfoLQ+gJQAdYvENp/AlSA/wNUpQBCAApwCPDW/4eC7xB77/+HA4h18s9gau0+gqn/BnBP/oQIIIz7T4KAPNBOdIGPICbZhiIc9hXi9DaYgMVH7J7jFYXxPyoQE+0AR6NhfJEcqMkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 1